import { GetAllExternalFlightBookingRequestsForAdminState } from './getAllExternalFlightBookingRequestsForAdmin.types'

const initialState: GetAllExternalFlightBookingRequestsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
